module.exports = __webpack_public_path__ + "static/media/banner_mobile.c1202c3a.png";